import { Navigate} from 'react-router-dom'
import Layout from '../layouts/layout'

const ProtectRouteReviewer = ()=>{
     
    const userData = JSON.parse(localStorage.getItem("userData"))

    return userData && (userData.userRole === "Reviewer" ) ? <Layout/> : <Navigate to='/'/>
}
export default ProtectRouteReviewer